import * as types from './mutation-types'

export default {
  [types.SET_LOADING](state, loading) {
    state.loading = loading
  },

  [types.SET_SUPPLIERS](state, suppliers) {
    state.suppliers = suppliers
  },

  [types.SET_PRODUCTS](state, products) {
    state.products = products
  },

  [types.SET_SUPPLY_DETAIL](state, supplyDetail) {
    state.supplyDetail = supplyDetail
  },

  [types.SET_SUPPLY_STATUSES](state, statuses) {
    state.supplyStatuses = statuses
  },
}
